import parseDialogue from "../../util/parseDialogue";

export const WintermutantL9 = parseDialogue(`
wintermutant:l9:100-300

#100 That battle was sooo kewl! You rock! And managed to retrieve that experimental wizard software.
>200 How does it work?

#200 The program should be ready to use, just plug and play. Oh, one more thing. I've been scanning these nodes. Be sure to get some level four software and be ready for nasty security. Go get 'em partner.
>300 Ready to receive software transfer.
`);
